import { GetterTree } from "vuex";
import { ILoyaltyState, LoyaltySchemeType, ICampaignMultiplier } from "./types";
import { IRootState } from "@/store/types";

export namespace LOYALTY_GETTERS {
  export const GET_CUSTOMER_AIRPOINTS_TOTAL: string =
    "getCustomerAirpointsTotal";
  export const GET_CUSTOMER_FLYBUYS_TOTAL: string = "getCustomerFlyBuysTotal";
}

export const getters: GetterTree<ILoyaltyState, IRootState> = {
  [LOYALTY_GETTERS.GET_CUSTOMER_AIRPOINTS_TOTAL](state: ILoyaltyState): number {
    if (state.customerPointsList) {
      const totalAirpoints =
        state.customerPointsList
          .filter(point => point.loyaltyScheme === LoyaltySchemeType.Airpoints)
          .reduce(
            (total: any, item: any) => Number(total) + Number(item.points),
            0
          ) || 0;

      return totalAirpoints;
    }

    return 0;
  },
  [LOYALTY_GETTERS.GET_CUSTOMER_FLYBUYS_TOTAL](state: ILoyaltyState): number {
    if (state.customerPointsList) {
      const totalFlybuys =
        state.customerPointsList
          .filter(point => point.loyaltyScheme === LoyaltySchemeType.FlyBuys)
          .reduce(
            (total: any, item: any) => Number(total) + Number(item.points),
            0
          ) || 0;

      return totalFlybuys;
    }
    return 0;
  }
};
